



















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Owner from "./Owner.vue";
import Guest from "./Guest.vue";
import LoggedinUserNotOwner from "./LoggedinUserNotOwner.vue";
import { JinroRoomDocument } from "@/services/datatypes";
import { JinroRoomStatus } from "../../../services/jinro-room-status";

@Component({
  components: {
    Owner,
    Guest,
    LoggedinUserNotOwner
  }
})
export default class ManagementJinroPlayers extends Vue {
  @Prop() readonly jinroRoom!: JinroRoomDocument;
  guestName = "";

  get hasUser(): boolean {
    return !!this.$store.state.firebaseUser;
  }

  get isOwner() {
    return (
      this.$store.state.firebaseUser &&
      this.jinroRoom.owner === this.$store.state.firebaseUser.uid
    );
  }

  get isInitialPlayerCreationCompleted(): boolean {
    if (!this.$store.state.jinroRoom) {
      return false;
    }
    const jinroRoom = this.$store.state.jinroRoom as JinroRoomDocument;

    return jinroRoom.jinroRoomStatus !== JinroRoomStatus.CreatingJinroRoom;
  }
}
